<template>
  <div
    class="locked-container"
    @click.stop="emit('click')"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <AddBlock
      v-if="isHovered"
      :column-padding-x="columnPaddingX"
      :block-width="blockWidth"
    />

    <div class="locked-overlay">
      <div
        v-show="isHovered"
        class="absolute right-[5px] top-[-16px] z-[50] flex items-center justify-center rounded-t-[3px] bg-content-1 px-1 py-0.5 font-inter text-[9px] font-semibold leading-3 text-white"
      >
        <svg
          data-testid="content-block-lock"
          style="width: 10px; height: 12px"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed, onMounted } from "vue";
  import AddBlock from "./addBlock.vue";

  import { useMjmlStore } from "@/stores/mjmlStore";

  const mjmlStore = useMjmlStore();

  const props = defineProps({
    sectionIndex: {
      type: Number,
      required: true,
    },

    columnIndex: {
      type: Number,
      required: true,
    },

    block: {
      type: Object,
      required: true,
    },
  });

  const isHovered = ref(false);
  const blockWidth = ref(0);

  const emit = defineEmits(["click"]);

  const columnPaddingX = computed(() => {
    const column =
      mjmlStore.getMjml().children[0].children[props.sectionIndex].children[
        props.columnIndex
      ];

    if (column && column.attributes && column.attributes.padding) {
      const padRaw = column.attributes.padding;
      const padding = padRaw.split(" ");
      return parseInt(padding[1]) + parseInt(padding[3]);
    }
    return 0;
  });

  function countBlockWidth() {
    if (mjmlStore.isMobileView && mjmlStore.isMobileFirstEnabled) {
      const columnsCount =
        mjmlStore.mjml.children[0].children[props.sectionIndex].children.length;

      return 375 / columnsCount;
    }

    const lefPaneWidth = 370;

    const editorViewWidth = window.innerWidth - lefPaneWidth;

    const blockPercentWidthOfColumn =
      mjmlStore.mjml.children[0].children[props.sectionIndex].children[
        props.columnIndex
      ].attributes["width"];

    const widthNum = parseInt(blockPercentWidthOfColumn) / 100;

    const columnWidth = props.block.attributes["containerWidth"] / widthNum;

    if (columnWidth < editorViewWidth) {
      return props.block.attributes["containerWidth"];
    } else {
      return editorViewWidth * widthNum;
    }
  }

  onMounted(() => {
    blockWidth.value = countBlockWidth();
  });
</script>

<style>
  .locked-container {
    width: 100%;
    display: table;
    position: relative;
  }

  .locked-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--c-locked-content);
    z-index: 2 !important;
  }

  .content-label {
    background-color: #00d7ca;
    color: white;
    position: absolute;
    right: 0;
    display: inline-block;
    font-family: Inter;
    font-size: 9px;
    line-height: 100%;
    font-weight: 600;
    text-transform: lowercase;
    padding: 3px;
    top: 0;
    margin-top: -17px;
    margin-right: 0px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
</style>
